import * as CheckboxR from "@radix-ui/react-checkbox";
import { useId } from "react";
import { FaCheck, FaMinus } from "react-icons/fa6";
import { css, cva, cx, type RecipeVariantProps } from "../../../../styled-system/css";

type Props = RecipeVariantProps<typeof rootClasses> & {
  label?: string;
  labelSide?: "left" | "right";
  value: boolean | "indeterminate";
  onChange?: (value: boolean) => void;
  isDisabled?: boolean;
  className?: string;
};

const rootClasses = cva({
  base: {
    all: "unset",
    display: "inline-flex",
    flex: "0 0 auto",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid {colors.trellisPalette.4}",

    borderRadius: "4px",
    width: "16px",
    minWidth: "0",
    height: "16px",
    color: "trellisPalette.4",
    fontSize: "large",
    backgroundColor: "white",
    boxShadow: "0 2px 10px {colors.black/10}",
    _disabled: {
      borderColor: "grey",
      color: "grey",
      backgroundColor: "lightGrey",
      _hover: {
        color: "grey",
        backgroundColor: "lightGrey",
      },
    },
    _focusVisible: {
      boxShadow: "0 0 0 2px black",
    },
    _hover: {
      color: "white",
      backgroundColor: "trellisPalette.4",
    },
  },
  variants: {
    size: {
      small: {
        width: "12px",
        height: "12px",
        fontSize: "xsmall",
      },
    },
  },
});

export function Checkbox({ value, onChange, label, labelSide = "right", size, isDisabled, className }: Props) {
  const inputId = useId();
  return (
    <div
      className={cx(
        css({
          display: "flex",
          gap: "small",
          alignItems: "center",
        }),
        className,
      )}
    >
      {labelSide === "left" && label && (
        <label
          htmlFor={inputId}
          className={css({
            fontSize: "large",
          })}
        >
          {label}
        </label>
      )}
      <CheckboxR.Root
        id={inputId}
        className={rootClasses({ size })}
        checked={value}
        onCheckedChange={onChange}
        disabled={isDisabled}
      >
        <CheckboxR.Indicator className={css({ display: "flex", justifyContent: "center", alignItems: "center" })}>
          {value === "indeterminate" && <FaMinus />}
          {value === true && <FaCheck />}
        </CheckboxR.Indicator>
      </CheckboxR.Root>
      {labelSide === "right" && label && (
        <label
          htmlFor={inputId}
          className={css({
            fontSize: "large",
          })}
        >
          {label}
        </label>
      )}
    </div>
  );
}
